import React from "react";
import { matchPath } from "react-router-dom";

import SidebarNavListItem from "./SidebarNavListItem";
import SidebarNavList from "./SidebarNavList";

const isMenuOpen = (page, currentRoute) => {
  if (page.href) {
    const hrefMatch = matchPath({ path: page.href, end: false }, currentRoute);
    if (hrefMatch) {
      return true;
    }
  }

  if (page.children) {
    return page.children.some((child) => isMenuOpen(child, currentRoute));
  }

  return false;
};

const reduceChildRoutes = (props) => {
  const { items, page, depth, currentRoute } = props;

  if (page.children) {
    const open = isMenuOpen(page, currentRoute);

    items.push(
      <SidebarNavListItem
        depth={depth}
        icon={page.icon}
        key={page.title}
        badge={page.badge}
        open={!!open}
        title={page.title}
        href={page.href}
      >
        <SidebarNavList depth={depth + 1} pages={page.children} />
      </SidebarNavListItem>
    );
  } else {
    items.push(
      <SidebarNavListItem
        depth={depth}
        href={page.href}
        icon={page.icon}
        key={page.title}
        badge={page.badge}
        title={page.title}
      />
    );
  }
  // console.log(items.map);

  return items;
};

export default reduceChildRoutes;
